/* tmData.js — Shared sample data v2 (ES Module) */

const MEMBERS = ['Arun Sharma','Priya Sharma','Rohit Yadav','Ankit Verma','Sneha Patel','Vikram Singh','Deepa Rao','Sanjay Kumar'];

const MODULES = {
  'P001':['Payroll','Attendance','Leave','Reports','Settings'],
  'P002':['Mobile App','API Layer','Push Notifications','Analytics'],
  'P003':['HR Portal','Onboarding','Performance','Recruitment'],
  'P004':['ERP Core','Finance Module','Inventory','Procurement'],
};

const SUBMODULES = ['Dashboard','List View','Detail View','Form','Report','Integration','Configuration','API Endpoint'];
const TYPES     = ['Bug','Enhancement'];
const SEGMENTS  = ['Web','iOS','Android','API'];
const STATUSES  = ['Open','In Progress','Review','Resolved','Closed'];
const PRIORITIES  = ['Critical','High','Medium','Low'];
const SEVERITIES  = ['Blocker','Critical','Major','Minor'];

const projects = [
  {id:'P001',name:'OrgGenie HRMS',
    description:'Comprehensive HR & Payroll management platform for BizBrolly. Covers the complete employee lifecycle — onboarding, attendance, leave, payroll processing, compliance, and offboarding. The platform is built to handle multi-company, multi-branch setups with role-based access and audit trails.',
    startDate:'2024-11-01',endDate:'2025-06-30',status:'Active',
    type:'Software Development',
    manager:'Arun Sharma',
    client:{name:'BizBrolly Solutions Pvt. Ltd.',location:'Noida, Uttar Pradesh',contact:'Arun Sharma',email:'arun@bizbrolly.com',phone:'+91 98765 43210',website:'bizbrolly.com'},
    members:['Arun Sharma','Priya Sharma','Rohit Yadav','Ankit Verma'],
    files:[{name:'PRD_v2.1.pdf',size:'1.2 MB',uploaded:'2025-01-10',by:'Arun Sharma'},{name:'UI_Mockups.fig',size:'8.4 MB',uploaded:'2025-02-03',by:'Priya Sharma'},{name:'API_Docs.docx',size:'340 KB',uploaded:'2025-02-20',by:'Rohit Yadav'}]},
  {id:'P002',name:'OrgGenie Mobile',
    description:'iOS and Android companion app for employees. Enables payslip access, leave application, attendance marking, and reimbursement submission on mobile devices. Designed with offline-first architecture for field employees.',
    startDate:'2025-01-15',endDate:'2025-08-31',status:'Active',
    type:'Mobile Application',
    manager:'Sneha Patel',
    client:{name:'BizBrolly Solutions Pvt. Ltd.',location:'Noida, Uttar Pradesh',contact:'Arun Sharma',email:'arun@bizbrolly.com',phone:'+91 98765 43210',website:'bizbrolly.com'},
    members:['Sneha Patel','Vikram Singh','Arun Sharma'],
    files:[{name:'Mobile_PRD.pdf',size:'890 KB',uploaded:'2025-01-20',by:'Sneha Patel'}]},
  {id:'P003',name:'HR Analytics Portal',
    description:'Data-driven HR insights dashboard with real-time analytics, headcount trends, attrition reports, and predictive workforce planning tools.',
    startDate:'2024-09-01',endDate:'2025-03-31',status:'Archived',
    type:'Web Application',
    manager:'Deepa Rao',
    client:{name:'TechCorp India',location:'Bengaluru, Karnataka',contact:'Ramesh Kumar',email:'ramesh@techcorp.in',phone:'+91 80012 34567',website:'techcorp.in'},
    members:['Deepa Rao','Sanjay Kumar'],
    files:[]},
  {id:'P004',name:'ERP Integration',
    description:'Connect OrgGenie with client ERP systems via REST APIs and webhooks. Handles bi-directional data sync for employees, payroll journals, and compliance reports.',
    startDate:'2025-02-01',endDate:'2025-09-30',status:'Active',
    type:'Integration',
    manager:'Priya Sharma',
    client:{name:'Reliance Industries',location:'Mumbai, Maharashtra',contact:'Suresh Mehta',email:'suresh.mehta@ril.com',phone:'+91 22 2278 5000',website:'ril.com'},
    members:['Priya Sharma','Rohit Yadav','Sanjay Kumar'],
    files:[{name:'Integration_Spec.xlsx',size:'210 KB',uploaded:'2025-02-10',by:'Priya Sharma'}]},
];

function sampleTitle(proj, idx) {
  var t = [
    'Fix login session timeout','Implement export to Excel','Performance optimisation on list view',
    'Add bulk action support','Update API response format','Mobile responsive layout fix',
    'Email notification not sending','Dark mode support','Role-based access control',
    'Integrate payment gateway','Search filter not working','PDF generation broken',
    'Add custom field support','Timezone handling issue','Refactor authentication module',
    'Unit tests for payroll service','Fix date picker on iOS','UI alignment on Android',
  ];
  return t[idx % t.length] + ' — ' + proj;
}

var tasks = [];
var tid = 1;
var stDist = ['Open','Open','Open','In Progress','In Progress','Review','Resolved','Closed'];

projects.forEach(function(p) {
  var mods = MODULES[p.id] || ['General'];
  for (var i = 0; i < 18; i++) {
    var status = stDist[i % stDist.length];
    var due = new Date(); due.setDate(due.getDate() + Math.floor(Math.random() * 60) - 20);
    var created = new Date(); created.setDate(created.getDate() - Math.floor(Math.random() * 60));
    var est = [2, 4, 8, 16, 24, 32][Math.floor(Math.random() * 6)];
    tasks.push({
      id:    'T' + String(tid).padStart(4, '0'),
      taskNo: 'TM-' + String(tid).padStart(3, '0'),
      projectId:    p.id,
      parentTaskId: (i > 0 && i % 5 === 0) ? 'T' + String(tid - 3).padStart(4, '0') : null,
      title:        sampleTitle(p.name, i),
      description:  'Detailed description for this task. Steps to reproduce and expected behaviour documented. Testing on staging environment required before close.',
      module:       mods[i % mods.length],
      subModule:    SUBMODULES[i % SUBMODULES.length],
      type:         TYPES[i % 2],
      segment:      SEGMENTS[i % 4],
      status:       status,
      priority:     PRIORITIES[i % 4],
      severity:     SEVERITIES[i % 4],
      raisedBy:     MEMBERS[(i + 2) % MEMBERS.length],
      assignedTo:   MEMBERS[i % MEMBERS.length],
      dueDate:      due.toISOString().split('T')[0],
      createdDate:  created.toISOString().split('T')[0],
      estimation:   est,
      loggedHours:  status === 'Closed' ? est : Math.round(est * (Math.random() * 0.8)),
      comments: [
        { author: MEMBERS[(i + 1) % MEMBERS.length], text: 'Investigating the root cause.', time: '2025-03-15 10:22' },
        { author: MEMBERS[(i + 2) % MEMBERS.length], text: 'Fix deployed to staging.', time: '2025-03-16 14:05' },
      ],
      history: [
        { action: 'Task created',   by: MEMBERS[(i + 2) % MEMBERS.length], from: null,   to: 'Open',        time: '2025-03-10 09:00' },
        { action: 'Status changed', by: MEMBERS[i % MEMBERS.length],       from: 'Open', to: 'In Progress', time: '2025-03-12 11:30' },
        { action: 'Assigned to ' + MEMBERS[i % MEMBERS.length], by: MEMBERS[(i + 2) % MEMBERS.length], from: null, to: null, time: '2025-03-12 11:35' },
      ],
      attachments: i % 3 === 0 ? [{ name: 'screenshot.png', size: '124 KB' }, { name: 'requirements.pdf', size: '340 KB' }] : [],
      tags: ['sprint-3', 'v2.1'],
    });
    tid++;
  }
});

const PROJECT_TYPES = ['Software Development','Mobile Application','Web Application','Integration','Consulting','Design','Research','Other'];

const DATA = {
  projects,
  tasks,
  members: MEMBERS,
  modules: MODULES,
  subModules: SUBMODULES,
  types: TYPES,
  segments: SEGMENTS,
  statuses: STATUSES,
  priorities: PRIORITIES,
  severities: SEVERITIES,
  projectTypes: PROJECT_TYPES,
};

export default DATA;
